<template>
  <div></div>
</template>

<script>
import API from '@/api/order'
export default {
  name: '',
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {
    this.postOrderCalcAmount()
  },
  methods: {
    postOrderCalcAmount() {
      let obj = {
        product: this.utils.getProductCode(),
        version: this.$route.params.version,
        time: this.$route.params.time,
        userCount: this.$route.params.userCount,
        storeCount: this.$route.params.storeCount,
        freeCode: this.$route.params.freeCode,
        agentId: ''
      }
      API.postOrderCalcAmount(obj).then(res => {
        console.log(res)
        this.$router.push({ name: 'Detail', params: { orderNum: res.data } })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>